module.exports = __webpack_public_path__ + "static/img/zs-03.1e86eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs-03.png
// module id = W3zg
// module chunks = 16